module.exports = __webpack_public_path__ + "static/media/debito-automatico.0ea6db33.svg";